export const ActivityDraftsItemComponent = {
  templateUrl:
    'activity/components/activity-drafts-item/activity-drafts-item.html',
};
